<div class="row mt-4" (click)="navigateToDetails()" style="cursor: pointer;">
  <ng-container *ngIf="position === 'right'; else leftPosition">
    <div class="row g-md-0" style="background-color: white;cursor: pointer;" (click)="navigateToDetails()">
      <div class="col-md-6 pe-0 image-col-mobile-left">
        <div class="bg-image-large-card ">
          <img
          [src]="image"
          (error)="image = './assets/home/image-error.png'"
          style="border-radius: 0 0 0 24px; width: 100%;"
          alt="Imagen relacionada con la noticia"
        />

          <div class="oxy-post-category tag-pill-large-card  category-on-large-image d-md-none"
           [ngStyle]="{
            'background-color': categoryBackgroundColor,
            'color': categoryFontColor
          }">
            {{category}}
          </div>
        </div>
      </div>

      <div class="col-md-6 ps-0 text-col-mobile-right">
        <div class="large-card-clip-card-wrapper position-relative">

          <div (click)="$event.stopPropagation()" style="cursor: pointer;">
           <app-reactions  [reactions]="reactions"  class="reactions-floating d-none d-md-block"></app-reactions>
           <app-reactions  [reactions]="reactions"  class="reactions-floating-mobile d-block d-md-none"></app-reactions>
          </div>

          <div class="large-card-clip-card">
            <div class="row">
              <div class="col-md-6 d-none d-md-block mt-1">
                <div class="oxy-post-category tag-pill-large-card "
                [ngStyle]="{
                  'background-color': categoryBackgroundColor,
                  'color': categoryFontColor
                }">

                  {{category}}
                </div>
              </div>
            </div>

            <div class="mt-5 mt-md-0">
            <h4 class="app-bold-text mt-3">{{title}}</h4>
            <h6 class="text-muted fw-bold d-none d-md-block">{{date | date: 'dd/MM/yyyy'}}</h6>

            <div class="oxy-post-excerpt text-muted mt-2 d-none d-md-block" [innerHTML]="content">
            </div>

            <div class="oxy-read-more d-block d-md-none mt-2" >
              Leer más
              <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Icono de ir a la página" />
            </div>

            <div class="row mt-3 d-none d-md-flex">
              <div class="col-md-6">
                <div class="oxy-read-more">
                  Leer más
                  <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Icono de ir a la página" />
                </div>
              </div>
              <div class="col-md-6 text-end">
                <div class="oxy-post-footer-container__right">
                  <img src="./../../../../../../assets/icons/clock.svg" alt="My icon" width="20" height="20" />
                  <span class="text-muted fw-bold ms-2">{{readingTime}}</span>
                </div>
              </div>
            </div>
            </div>
          </div>
         </div>
        </div>
    </div>
  </ng-container>

  <ng-template #leftPosition>
    <div class="row g-md-0" style="cursor: pointer;" (click)="navigateToDetails()">
      <div class="col-md-6 ps-0 text-col-mobile-right">
        <div class="large-card-reverse-clip-card-wrapper position-relative">

          <div (click)="$event.stopPropagation()" style="cursor: pointer;">
           <app-reactions [reactions]="reactions"  class="reactions-floating d-none d-md-block"></app-reactions>
           <app-reactions [reactions]="reactions"  class="reactions-floating-mobile d-block d-md-none"></app-reactions>
          </div>

          <div class="large-card-reverse-clip-card" style="border-bottom-left-radius: 24px;">
            <div class="row">
              <div class="col-md-6 d-none d-md-block mt-1">
                <div class="oxy-post-category tag-pill-large-card"
                [ngStyle]="{
                  'background-color': categoryBackgroundColor,
                  'color': categoryFontColor
                }">
                {{category}}
                </div>
              </div>
            </div>

            <div class="mt-5 mt-md-0">
            <h4 class="app-bold-text mt-3 ">
           {{title}}
            </h4>
            <h6 class="text-muted fw-bold d-none d-md-block">{{date | date: 'dd/MM/yyyy'}}</h6>

            <div class="oxy-post-excerpt text-muted mt-2 d-none d-md-block" [innerHTML]="content">
            </div>

            <div class="oxy-read-more d-block d-md-none mt-2">
              Leer más
              <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Icono de ir a la página" />
            </div>

            <div class="row mt-3 d-none d-md-flex">
              <div class="col-md-6">
                <div class="oxy-read-more">
                  Leer más
                  <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Icono de ir a la página" />
                </div>
              </div>
              <div class="col-md-6 text-end">
                <div class="oxy-post-footer-container__right">
                  <img src="./../../../../../../assets/icons/clock.svg" alt="My icon" width="20" height="20" />
                  <span class="text-muted fw-bold ms-2">{{readingTime}}</span>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
       </div>

      <div class="col-md-6 pe-0 image-col-mobile-left">
        <div class="bg-image-large-card ">
          <img
            src={{image}}
            (error)="image = './assets/home/image-error.png'"
            style="border-radius: 0 0 24px 0; width: 100%;"
            alt="Imagen relacionada con la noticia"
          />
          <div class="oxy-post-category tag-pill-large-card  category-on-large-image d-md-none"
          [ngStyle]="{
            'background-color': categoryBackgroundColor,
            'color': categoryFontColor
          }"
          >
            {{category}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
